import {CommandBase} from './command-base';

export class SubscribeRolesCommand extends CommandBase {
  constructor() {
    super('SubscribeRolesCommand');
  }
}
